// extracted by mini-css-extract-plugin
export default {"navDivider":"FAQs_navDivider__7VeUi","main_home_container":"FAQs_main_home_container__nKYgg","mainContent":"FAQs_mainContent__4+WKu","faq_area":"FAQs_faq_area__DQX6l"};